export class AppCues {
  identify(user) {
    window.Appcues.identify(user.userId, user);
  }

  track(event, data) {
    window.Appcues.track(event, data);
  }
}
